import {generalRequest} from "@/lib/services/requests";
import {useMutation, useQuery} from "@tanstack/react-query";

export const useApiSearchStudentScores = (args) => {
    return useQuery({
        queryKey: ['student', 'scores', 'list', args],
        queryFn: ({pageParam = args.page ?? 1}) => (((config) => {
            return generalRequest.get(`/student/scores`, {params: config})
        })({...args, page: pageParam})),
    })
}


export function useApiUpdateTeacherStudentScores() {
    return useMutation({
        mutationFn: (data) =>
            (((data) => {
                return generalRequest.put(`/teacher/scores`, data)
            })(data))
    });
}
